// extracted by mini-css-extract-plugin
export var dividerContainer = "_88-0";
export var line = "_88-1";